import { render, staticRenderFns } from "./editLog.vue?vue&type=template&id=868670e2&scoped=true"
import script from "./editLog.vue?vue&type=script&lang=js"
export * from "./editLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868670e2",
  null
  
)

export default component.exports